<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:0">
      <div class="title-font-style">
        <span>退货信息</span>
      </div>
      <el-form class="details-line-height inner-from" label-width="70px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="退货编号：">{{form.returnNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="售后类型：">{{form.afterSalesType}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发起时间：">{{form.createTime|dateFilter}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户名称：">
              <span class="approval" @click="onCusName">{{queryParams.cusName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="退货状态："
            >{{form.returnState===1?'退货审批':form.returnState===3?'审批不通过':form.returnState===12?'退货完成':form.returnState===11?'放弃退货':'退货中'}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="销售总额：">{{form.salePriceTotal|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="退货说明：">{{form.returnMark}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row :gutter="20">
      <el-col :span="18">
        <sales-program
          ref="salesProgramRefs"
          v-show="activeName==='退货方案'"
          :params="queryParams"
          @onRefresh="getList"
        ></sales-program>
        <sales-refund-logistics ref="salesRefundLogisticsRefs" v-show="activeName==='物流管理'"></sales-refund-logistics>
        <sales-refund-contract ref="salesRefundContractRefs" v-show="activeName==='合同管理'"></sales-refund-contract>
        <confiscated-invoice ref="confiscatedInvoiceRefs" v-show="activeName==='罚没金开票'" @onSuccess='getList'></confiscated-invoice>
        <sales-refund-settlement ref="salesRefundSettlementRefs" v-show="activeName==='退款结算'" @onSuccess='getList'></sales-refund-settlement>
      </el-col>
      <el-col :span="6">
        <div
          class="item-box-content"
          v-for="(item,i) in list"
          :key="i"
          v-show="item.name!==activeName"
        >
          <div class="title-font-style">
            <span>{{item.name}}</span>
          </div>
          <div v-if="queryParams.returnPlainStatus>6&&queryParams.returnPlainStatus!==11">
            <div v-if="item.info" class="maintain-scheme">{{item.info}}</div>
            <el-table
              v-else
              style="margin-top:20px;"
              border
              ref="tableRef"
              :data="[item]"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
            >
              <el-table-column :label="item.type" prop="typeVal" min-width="100px"></el-table-column>
              <el-table-column :label="item.state" prop="stateVal" show-overflow-tooltip></el-table-column>
              <el-table-column label="操作">
                <template>
                  <el-button type="text" @click="onDetails(item,i)">前往</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            v-else
            class="maintain-scheme"
          >{{queryParams.returnPlainStatus===11?'放弃退货':'待结算审批通过'}}</div>
        </div>
      </el-col>
    </el-row>
    <!-------------- 取消维修 -------------->
    <!-- <cancel-maintain-dialog ref="cancelMaintainDialogRefs"></cancel-maintain-dialog> -->
  </div>
</template>
<script>
import salesProgram from './salesProgram' // 退货方案
import salesRefundLogistics from './salesRefundLogistics' // 物流管理
import salesRefundContract from './salesRefundContract' // 合同管理
import confiscatedInvoice from './confiscatedInvoice' // 罚没金开票
import salesRefundSettlement from './salesRefundSettlement' // 退款结算
// import cancelMaintainDialog from '../../dialog/cancelMaintainDialog'
import { returnDetails } from '@/api/sell/sellManage'
import { salesReturnStateFilter } from '@/util/filterCommon'
export default {
  components: {
    'sales-program': salesProgram,
    'sales-refund-logistics': salesRefundLogistics,
    'sales-refund-contract': salesRefundContract,
    'confiscated-invoice': confiscatedInvoice,
    'sales-refund-settlement': salesRefundSettlement
    // 'cancel-maintain-dialog': cancelMaintainDialog
  },
  data() {
    return {
      activeName: '退货方案',
      form: {},
      queryParams: {},
      list: [
        {
          name: '退货方案',
          type: '方案类型',
          typeVal: '销售售后退货',
          state: '退货状态',
          stateVal: '',
          info: ''
        },
        {
          name: '物流管理',
          type: '物流类型',
          typeVal: '退货入库',
          state: '物流状态',
          stateVal: '',
          info: ''
        },
        {
          name: '合同管理',
          type: '合同类型',
          typeVal: '销售退货合同',
          state: '合同状态',
          stateVal: '',
          info: ''
        },
        {
          name: '罚没金开票',
          type: '开票类型',
          typeVal: '售后退货',
          state: '开票状态',
          stateVal: '',
          info: ''
        },
        {
          name: '退款结算',
          type: '结算类型',
          typeVal: '售后退货',
          state: '结算状态',
          stateVal: '',
          info: ''
        }
      ]
    }
  },
  mounted() {
    this.getList()
    if (this.$route.query.activeName) {
      const index = this.list.findIndex(
        (m) => m.name === this.$route.query.activeName
      )
      if (index !== -1) {
        this.onDetails({ name: this.$route.query.activeName }, index)
      }
    }
  },
  methods: {
    getList() {
      returnDetails(this.$route.query.id, this.$route.query.cusId).then(
        (res) => {
          if (res.data.code === 200) {
            // res.data.obj.returnPlainStatus = 9
            this.queryParams = res.data.obj
            this.form = res.data.obj.orderContractSalereturnGoods
            this.list[0].stateVal = salesReturnStateFilter(
              res.data.obj.returnPlainStatus
            )
            this.list[1].stateVal =
              res.data.obj.logisticsStatus === 2 ? '已入库' : '待入库'
            this.list[2].stateVal =
              res.data.obj.orderContractBaseStatus === 2 ? '已生成' : '未生成'
            this.list[3].stateVal =
              res.data.obj.forfeitureInvoiceStatus === 2
                ? '已开票'
                : res.data.obj.forfeitureInvoiceStatus === 3
                  ? '开票中'
                  : '未开票'
            this.list[4].stateVal =
              res.data.obj.returnPriceStatus === 2 ? '已结算' : '未结算'
            if (res.data.obj.returnPlainStatus > 6) {
              this.list[1].info =
                res.data.obj
                  .orderContractSaleReturnGoodsContentDeliverStateThree
                  .length === 0
                  ? '退货任务中不存在已发货产品'
                  : res.data.obj.returnPlainStatus === 7
                    ? '待票据回收后进行入库'
                    : ''
              this.list[3].info = res.data.obj.costSettlementSchemeVo
                .customerCommitment
                ? ''
                : '退货任务中不存在客担罚没'
              this.list[4].info =
                res.data.obj.returnPlainStatus < 9
                  ? '待退货产品全部入库后结算'
                  : ''
            }
          }
        }
      )
    },
    onCusName() {
      this.$router.push({
        name: 'customer/details',
        query: { id: this.$route.query.cusId }
      })
    },
    onDetails(row, i) {
      this.activeName = row.name
      if (i === 0) {
        this.getList()
      } else if (i === 1) {
        this.$refs.salesRefundLogisticsRefs.getList()
      } else if (i === 2) {
        this.$refs.salesRefundContractRefs.getList()
      } else if (i === 3) {
        this.$refs.confiscatedInvoiceRefs.getList(
          this.queryParams.ocbId,
          this.queryParams.forfeitureInvoiceStatus
        )
      } else if (i === 4) {
        this.$refs.salesRefundSettlementRefs.getList(this.queryParams)
      }
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 取消维修
    onCancelMaintain() {
      this.$refs.cancelMaintainDialogRefs.onInitial()
    },
    // 查看产品序列号
    onSee() {}
  }
}
</script>
<style lang="scss" scoped>
.maintain-scheme {
  height: 80px;
  background: rgba(243, 247, 255, 1);
  border-radius: 4px;
  text-align: center;
  line-height: 80px;
  margin-top: 20px;
}
</style>
